import { useContext } from "react";
import { LibraryCreativesContext } from "./LibraryCreativesProvider";

export const useLibraryCreativesContext = () => {
  const context = useContext(LibraryCreativesContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
};
